var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeaf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 571,
    height: 551,
    viewBox: "0 0 571 551",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M207.236 244.398L286.44 323.602L366.243 243.799C377.058 232.983 385.659 220.164 391.554 206.075C397.449 191.985 400.522 176.9 400.599 161.681C400.676 146.462 397.754 131.407 392.001 117.376C386.248 103.345 377.775 90.6123 367.068 79.9052L288.045 0.882198L208.06 80.8677C186.265 102.662 173.934 132.136 173.78 162.803C173.625 193.471 185.66 222.822 207.236 244.398Z",
    fill: "#A9DCE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M326.402 430.038L326.402 550.627L446.701 550.627C463.005 550.627 479.149 547.416 494.212 541.178C509.274 534.939 522.961 525.795 534.49 514.268C546.018 502.741 555.163 489.056 561.402 473.995C567.641 458.934 570.853 442.792 570.853 426.49L570.853 306.177L450.279 306.177C417.425 306.177 385.917 319.226 362.685 342.455C339.454 365.683 326.402 397.188 326.402 430.038Z",
    fill: "#A9DCE6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.467773 426.779L0.467773 306.19L122.51 306.19C139.05 306.19 155.428 309.401 170.709 315.639C185.99 321.877 199.875 331.021 211.571 342.549C223.266 354.076 232.544 367.76 238.874 382.821C245.203 397.882 248.461 414.025 248.461 430.326L248.461 550.64L126.14 550.64C92.8097 550.64 60.8445 537.59 37.2763 514.362C13.7082 491.133 0.467773 459.629 0.467773 426.779Z",
    fill: "#A9DCE6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.04c080eb0ab23d3c6ceeb8e0f5cabcec.svg";
export { ForwardRef as ReactComponent };